<!-- 货主费用管理 -->
<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
            @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :flagList="['bgmId']" :searchList="pageShowData.jurHead.jurconfigform"
               :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
               <template slot="searchInput" slot-scope="{formOneValue}">
                  <el-input v-if="formOneValue.entityField == 'bgmId'" clearable
                     @focus="$refs['showSelectData'].openBox('businessGoodsList', 'bgmId', 'bgmId')"
                     v-model="getRequestData.bgmName" :maxlength="$store.state.inputLength">
                  </el-input>
               </template>
            </v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table @sort-change="sortChange"   v-if="pageShowData.jurTableVo" ref="mainTable" stripe :data="returnData.list" :height="tableHeight"
            :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
            show-summary :summary-method="getSummaries">
            <el-table-column label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column :sortable="tableValye.isSort == 1?'custom':false" align="center" v-if="tableValye.isShow == 1"
               v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
               :prop="tableValye.entityField" :min-width="tableValye.fieldWeight" show-overflow-tooltip
               :label="tableValye.showField">
               <template slot-scope="scope">
                  <!-- v-else-if="tableValye.entityField == 'isIntercept'"  -->
                  <span v-if="tableValye.fieldType == 'date'">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                  </span>
                  <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
                     $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
            @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
            @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
      <processAuditAction ref="processAuditAction"></processAuditAction>
      <el-dialog title="红冲" v-if="moneyShow" :visible.sync="moneyShow" width="500px">
         <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="100px" class="demo-ruleForm"
            :show-message="false" :inline-message="false">
            <el-form-item label="费用金额" prop="totalMoney" :rules="[{ required: true, trigger: ['blur', 'change'] },]">
               <el-input type="number" v-model.number="sendDataInfo.totalMoney" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="税额" prop="taxMoney" :rules="[{ required: true, trigger: ['blur', 'change'] },]">
               <el-input type="number" v-model.number="sendDataInfo.taxMoney" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="不含税金额" prop="totalntaxMoney"
               :rules="[{ required: true, trigger: ['blur', 'change'] },]">
               <el-input type="number" disabled v-model.number="sendDataInfo.totalntaxMoney"
                  autocomplete="off"></el-input>
            </el-form-item>
         </el-form>
         <span slot="footer" class="dialog-footer">
            <el-button @click="moneyShow = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('sendDataInfo')">确 定</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {},
         returnData: {
            total: 0, // 总条数
            list: [],
         },
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         seId: "",
         height: "",
         seTitle: "",
         seWidth: "",
         DialogVisible: false,
         seType: "",
         smId: "",
         parentSearchData: {},
         sField: "",
         requesUrl: "",
         moneyShow: false,
         ormId: "",
         sendDataInfo: {
            totalMoney: 0,
            totalntaxMoney: 0,
            taxMoney: 0
         }

      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.cmId = "";
            }
         },
         deep: true,
      },
      "sendDataInfo.totalMoney": {
         handler: function (newValue, oldValue) {
            this.$set(this.sendDataInfo, 'totalMoney', this.$common.updataNum('totalMoney', this.sendDataInfo).totalMoney)
            this.sendDataInfo.totalntaxMoney = this.$common.getDecimalInfo(3, (this.sendDataInfo.totalMoney || 0) + (this.sendDataInfo.taxMoney || 0))
         },
         deep: true,
      },
      "sendDataInfo.taxMoney": {
         handler: function (newValue, oldValue) {
            this.$set(this.sendDataInfo, 'taxMoney', this.$common.updataNum('taxMoney', this.sendDataInfo).taxMoney)
            this.sendDataInfo.totalntaxMoney = this.$common.getDecimalInfo(3, (this.sendDataInfo.totalMoney || 0) + (this.sendDataInfo.taxMoney || 0))
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 子组件触发
      drawerCancel(commitData) {
         this.showStatus = false
         commitData && this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage({
               //向窗口发送MessageEvent消息
               cmd: "returnFormJson",
               params: {
                  isPenetrate
               }, //参数
            },
               "*"
            );
         }
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.parentSearchData[type] = this.getRequestData[type];
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId]
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
            this.getButtonList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 3:
               var dataInfo = this.returnData.list[this.selectedDataIndex]
               if (!dataInfo) {
                  return this.$message.error("请勾选数据")
               }
               this.$refs["processAuditAction"].openBox(1, dataInfo.cmfrId);
               break;
            case 4:
               var dataInfo = this.returnData.list[this.selectedDataIndex]
               if (!dataInfo) {
                  return this.$message.error("请勾选数据")
               }
               this.submitForm()
               break;
            case 5:
               //导出
               this.exportData()
               break;
         }
      },
      //  导出
      exportData() {
         window.location.href = this.requesUrl + '/cmfeeregist/exportHisData?ormId=' + String(this.ormId) + '&cmId=' + this.getRequestData.cmId
                + '&cmName=' + this.getRequestData.cmName + '&start=' + this.getRequestData.start + '&end=' + this.getRequestData.end
                + '&state=' + this.getRequestData.state + '&page=' + this.getRequestData.page + '&rows=' + this.getRequestData.rows
      },
      submitForm() {
         this.$confirm('是否要红冲?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            const res = await this.$http.cmfeeregistaddRed({ ids: [dataInfo.cmfrId] })
            if (res.status == 200) {
               this.$message.success(res.message)
               this.getDataList()
            } else {
               this.$message.error(res.message)
            }
         }).catch(() => {
         });

      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },
      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.cmfeeregistqueryHis(
            this.getRequestData
         );
         if (responseData && responseData.status == 200) {
            let resData = JSON.parse(JSON.stringify(responseData));
            this.returnData.list = resData.result.list;
            this.returnData.total = resData.result.total;
            this.selectedDataIndex = 0;
            this.$nextTick(() => {
               this.$refs.mainTable && this.$refs.mainTable.doLayout();
            })
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
      getSummaries(param) {
         let { columns, data } = param;
         const sums = [];
         columns.forEach((column, index) => {
            if (index === 0) {
               sums[index] = '合计';
               return;
            }
            if (column.property === 'unsettlementMoney' || column.property === 'settlementMoney' || column.property === 'totalMoney') {
               const values = data.map(item => Number(item[column.property]));
               if (!values.every(value => isNaN(value))) {
                  let num = values.reduce((prev, curr) => {
                     const value = Number(curr);
                     if (!isNaN(value)) {
                        return prev + curr;
                     } else {
                        return prev;
                     }
                  }, 0);
                  sums[index] = this.$common.getDecimalInfo(3, num);
               } else {
                  sums[index] = '';
               }
            } else {
               sums[index] = '';
            }
         });
         return sums;
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.ormId = sessionStorage.getItem('ormId')
      this.getPageInfo();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}
</style>